import { fetchProductInfoActionTypes } from '../constants/productInfoActionTypes';
export const setProductInfoOutOfSync = () => ({
  type: fetchProductInfoActionTypes.OUT_OF_SYNC
});